import state from './moduleInternalChatMessagesState'
import actions from './moduleInternalChatMessagesActions'
import getters from './moduleInternalChatMessagesGetters'
import mutations from './moduleInternalChatMessagesMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}